<!-- <div *ngIf="showLoader" class="loader-container">
    <div class="loader"></div>
    <div class="loadingText">
    <span class="d-block mb-3">Processing...</span>
  </div>
    <button class="btn btn-secondary" (click)="cancelLoading()">Cancel</button>
  </div> -->
  <div *ngIf="showLoader" class="loader-container">
  <ng-template #customTemplate>
    <div class="loader"></div>
    <div class="loadingText">
      <span class="d-block mb-3">Processing...</span>
      <button class="btn btn-secondary" (click)="cancelLoading()">Cancel</button>
    </div>
  </ng-template>
  <ngx-loading [show]="showLoader" [config]="{ backdropBorderRadius: '3px'}"
    [template]="customTemplate"></ngx-loading>
  </div>